@if (Generateur) {
<div class="container-fluid mt-3 ">
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col fw-bold text-center mb-3">
            Liste des PSV
        </div>
        <div class="row">
            @for (sp of getUniquePSV(); track sp) {
            <div class="col-6 text-center">
                {{sp.Name}}
            </div>
            }
        </div>
    </div>
    <div class="row justify-content-center my-2">
        <mat-slide-toggle class="col-auto" [(ngModel)]="FullForm">Saisie complète </mat-slide-toggle>
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Appareil
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col-12">
            <mat-label>Heure de prelevement</mat-label>
            <input matInput placeholder="Heure de prelevement" [ngxTimepicker]="timepicker1" [format]="24" [value]="TimeSampling" readonly>
            @if (TimeSampling) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSampling()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetSampling($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Num Serie</mat-label>
            <input matInput [(ngModel)]="Generateur.NumSerie" placeholder="Num Serie">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Num Appareil</mat-label>
            <input matInput [(ngModel)]="Generateur.NumAppareil" placeholder="Num Appareil">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Marque</mat-label>
            <input matInput [(ngModel)]="Generateur.Marque" placeholder="Marque">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Modele</mat-label>
            <input matInput [(ngModel)]="Generateur.Modele" placeholder="Modele">
        </mat-form-field>
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Générateurs de dialyse
        </span>
    </div>
    @for (prel of Generateur.PrelevementGenerateurDialyseList; track prel; let j = $index) {
    <span>
        <div class="row rounded-1 background-light mb-3 py-3">
            <div class="text-center fw-bold mb-3">
                {{prel.Prelevement.SamplingPoint.Name}}
            </div>
            @if (prel.Prelevement.Comment) {
            <div class="text-center fst-italic mb-3">
                {{prel.Prelevement.Comment}}
            </div>
            }
            <mat-form-field class="col-12">
                <mat-label>Code OGI</mat-label>
                <input matInput [(ngModel)]="prel.Prelevement.OgiCode" placeholder="Code OGI" readonly>
            </mat-form-field>
            <!-- <mat-form-field class="col-12">
          <mat-select placeholder="Localisation" [(ngModel)]="prel.Localisation" required>
            <mat-option *ngFor="let o of LocalisationDialyseList; let i = index" [value]="i + 1">
              <span>{{o}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field> -->
            <mat-form-field class="col-12">
                <mat-label>Mode de désinfection</mat-label>
                <mat-select placeholder="Mode de désinfection" [(ngModel)]="prel.ModeDesinfection" required>
                    @for (o of ModeDesinfectionList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if (prel.Localisation === ELocalisationDialyse.Autre) {
            <mat-form-field class="col-12">
                <mat-label>Localisation</mat-label>
                <input matInput [(ngModel)]="prel.AutreLocalisation" placeholder="Localisation">
            </mat-form-field>
            }
            @if (FullForm) {
            <mat-form-field class="col-12">
                <mat-label>Bicarbonate (mmol/L)</mat-label>
                <input matInput type="number" [(ngModel)]="prel.Bicarbonate" placeholder="Bicarbonate  (mmol/L)">
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Sodium (mmol/L)</mat-label>
                <input matInput type="number" [(ngModel)]="prel.Sodium" placeholder="Sodium (mmol/L)">
            </mat-form-field>
            }
            <mat-form-field class="col-12">
                <mat-label>Observation</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
                          [(ngModel)]="prel.Observations" placeholder="Observation"></textarea>
            </mat-form-field>
        </div>
        <div class="row">
            <span class="ms-5 fw-bold">
                Flacons
            </span>
        </div>
        @if (prel.Prelevement.FlaconList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (flacon of prel.Prelevement.FlaconList; ; track flacon; let i = $index) {
                @if (FullForm || (!FullForm && flacon.Type !== EFlaskType.S1)) {
                <div class="row">
                    <div class="col-6">{{flacon.Code}}</div>
                    <div class="col-6">{{getFlaskTypeLabel(flacon.Type)}}</div>

                    <button class="col-auto" matPrefix mat-icon-button aria-label="barcode">
                        <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                    </button>
                    <mat-form-field class="col">
                        <mat-label>Barcode</mat-label>                                                                                           
                        <input matInput [(ngModel)]="flacon.Barcode" placeholder="Barcode" (keydown)="checkBarCode($event, flacon.Barcode)" [id]="'barcode'+EServiceType.Dialyse+'-'+j+'-'+i"
                               (keyup)="checkBarCodeExistence(flacon.Code) ; focusNext(flacon.Barcode, j, i, EServiceType.Endoscope, prel.Prelevement.FlaconList.length)" [readonly]="canBeDisabled(flacon)">
                        @if (flacon.Barcode) {
                        <button matSuffix mat-icon-button aria-label="Clear" (click)="flacon.Barcode=''">
                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                </div>
                }
                }
            </div>
        </div>
        }
        @if (Intervention?.Status !== EInterventionStatus.Preview) {
        <div class="row">
            <span class="ms-5 fw-bold">
                Consommables
            </span>
        </div>
        <div class="row mb-3">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button
                    (throttledClick)="openConsommableBox(EServiceType.Dialyse, prel.Prelevement)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
        }
        @if (prel.Prelevement.ConsommableList.length > 0) {
        <div class="row ">
            <div class="col-12">
                @for (cons of prel.Prelevement.ConsommableList; track cons; let i = $index) {
                <div class="row rounded-1 mb-3 py-3 background-light">
                    <div class="col-4 text-end">Type</div>
                    <div class="col-8"> {{getConsommableDialyseLabel(cons.Type)}}</div>
                    <div class="col-4 text-end">Numéro Lot</div>
                    <div class="col-8 ">{{cons.NumeroLot}}</div>
                    <div class="col-4 text-end">Expiration</div>
                    <div class="col-8">{{cons.Expiration!.toLocaleString()}}</div>
                    <div class="col-12 text-end">
                        <button appPreventDoubleClick class="" color="primary" mat-icon-button
                                (throttledClick)="openConsommableBox(EServiceType.Dialyse, prel.Prelevement, cons)">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                        <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteConsommable(cons, prel.Prelevement)">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
        }
    </span>
    }
    @if (Intervention?.Status !== EInterventionStatus.Preview) {
    <div class="row mb-3">
        <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="showAlert(false)">
            Enregistrer
        </button>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col-12" color="accent" mat-raised-button (throttledClick)="showAlert(true)">
            Terminer et Enregistrer
        </button>
    </div>
    }
</div>
}